<template>
    <div class="container" style="position: relative; top: 60px; margin-left: 13px;" v-if="ready">
        <div v-if="results.length" class="row">
            <h2>{{ winner }} wins!</h2>
        </div>
        <div class="row">
            <div class="col-md-4">
                <img :src="`${siteUrl}/${animation}`" width="300"/>
            </div>
            <div v-if="map && screenshot" class="col-md-4">
                <img v-if="screenshot" :src="`${siteUrl}/screens/${screenshot}`" width="300" />
            </div>
            <div class="col-md-4">
                <h4>{{ createdOn | dateTime }}</h4>
                <h4>{{ map.name }} by {{ map.author }}</h4>
                {{ gameType}} hosted by {{ host }}<br/>
                <div v-if="canEdit">
                    <br/>
                    <button class="ol-featured_button" @click="calculate">Calculate</button>
                </div>
            </div>
        </div>
        <br/>
        <div class="row">
            <div v-if="notes" v-html="notes"></div>
            <table class="table table-condensed">
                <thead>
                    <th>Player</th>
                    <th>Played as</th>
                    <th>Kills</th>
                    <th>Deaths</th>
                    <th>Suicides</th>
                    <th>KDR</th>
                    <th>Score</th>
                    <th>Killstreak</th>
                </thead>
                <tbody>
                    <tr v-for="result in results" :key="result._id">
                        <td>{{ result.player }}</td>
                        <td>{{ character(result) }}</td>
                        <td>{{ result.kills }}</td>
                        <td>{{ result.deaths }}</td>
                        <td>{{ result.suicides }}</td>
                        <td>{{ result.kdr }}</td>
                        <td>{{ result.score }}</td>
                        <td>{{ result.killstreak }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <br/>
        <div class="row">
            <div class="col-md-12">
                <h3>The Play by Play Recap</h3>
                <ul class="list-unstyled">
                    <li v-for="message in messages" :key="message.id">{{ message.output }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { api } from '../framework/api';
import { settings } from '../framework/settings';
import _ from 'lodash'
import NoImage from './primitives/NoImage'
import toastr from 'toastr'
const playerMap = {
    'M': 'Mary',
    'B': 'Bob',
    'J': 'James',
    'S': 'Sanchez',
    'D': 'Dr. Death',
    'T': 'Two Feathers'
}

export default {
    components: { NoImage },
    props: { id: String },
    data() {
        return {
            ready: false,
            createdOn: null,
            screenshot: null,
            map: null,
            host: null,
            gameType: null,
            results: [],
            messages: [],
            players: [],
            siteUrl: settings.siteUrl
        }
    },
    computed: {
        canEdit() {
            return this.sharedState.canReview;
        },
        winner() {
            return this.results[0].player;
        },
        animation() {
            var map = {
                'M': 'mary.gif',
                'D': 'drdeath.gif',
                'J': 'james2.gif',
                'S': 'sanchez.gif',
                'T': 'chief.gif',
                'B': 'bob1.gif'
            };
            let player = this.results[0];
            let animation = null;
            if(player && player.character) {
                animation = map[player.character];
            }

            return animation || 'giphy_james.gif';
        }
    },
    methods: {
        async calculate() {
            await api.post(`game/${this.id}`);
            await this.loadGame();
            toastr.success('Game has been updated');
        },
        character(result) {
            if(!result.character) return '';
            return playerMap[result.character];
        },
        async loadGame() {
            let result = await api.get(`game/${this.id}`);
            this.createdOn = result.data.createdOn;
            this.map = result.data.map;
            this.screenshot = result.data.map.screenshot;
            this.host = result.data.host;
            this.gameType = result.data.gameType;
            this.results = result.data.results;
            this.players= result.data.messageBuffer.players;
            this.notes = '';
            var id = 0;
            this.messages = result.data.messageBuffer.messages.map(msg => {
                let reader = result.data.statsReader || this.host;
                if(msg == 'You blew yourself up!') {
                    msg = `${reader} self-destructed!!`;
                }
                else if(msg.endsWith('blew you up!')) {
                    msg = msg.replace('you up', `up ${reader}`)
                }
                else if(msg == 'You fell to your death!') {
                    msg = `${reader} died from a fall!`;
                }
                else {
                    msg = msg.replace('you!', `${reader}!!`);
                }
                return { id: ++id, output: msg };
            });

            result.data.results.forEach(result => {
                let ds = result.dynamiteStats;
                let things = ds.deaths + ds.kills + ds.suicides;
                if(things) {
                    let died = ds.deaths ? `exploded ${ds.deaths} times ` : '';
                    let killed = ds.kills ? `scored ${ds.kills} with dynamite `: '';
                    let suicides = ds.suicides ? `blew himself up ${ds.suicides} times` : '';
                    this.notes += `${result.player}, playing as ${this.character(result)}, ${died} ${killed} ${suicides}<br/>`;
                }
            });
            
            if(this.notes) {
                this.notes += '<br/>';
            }
        }
    },
    async created() {
        await this.loadGame();
        this.ready = true;
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Game.vue